
import Button from '../base/Button';

export default function HeroSection() {
  const handleBuyNow = () => {
    window.open('https://entrega.logzz.com.br/pay/mem6qvd4r/1-kit-com-6-facas-promocao', '_blank');
  };

  return (
    <section className="bg-gradient-to-br from-gray-50 to-gray-100 py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          {/* Título chamativo */}
          <h1 className="text-3xl lg:text-5xl font-bold text-gray-800 leading-tight">
            Depois desse Kit Profissional,
            <span className="text-red-600 block">VOCÊ VAI QUERER JOGAR FORA TODAS AS SUAS FACAS</span>
          </h1>
          
          {/* Imagem do produto */}
          <div className="relative max-w-2xl mx-auto">
            <img 
              src="https://static.readdy.ai/image/32da3dbc6c077a42865d0d012e77efdf/8c6cd0141cb04a725fb5ea55860adf7a.webp"
              alt="Kit de Facas Profissional"
              className="w-full h-auto rounded-lg shadow-2xl object-top"
            />
            <div className="absolute -top-4 -right-4 bg-red-600 text-white px-4 py-2 rounded-full font-bold text-lg shadow-lg">
              OFERTA!
            </div>
          </div>
          
          {/* Oferta */}
          <div className="space-y-6">
            <p className="text-xl text-gray-600">
              Kit De Facas 6 Peças De Chefe Profissional Cocin Master
            </p>
            
            <div className="space-y-4">
              <div className="flex items-center justify-center gap-4">
                <span className="text-lg text-gray-400">De</span>
                <span className="text-2xl text-gray-400 line-through">R$ 219,99</span>
                <span className="text-lg text-gray-600">por</span>
              </div>
              <div className="flex items-center justify-center gap-4">
                <span className="text-5xl font-bold" style={{color: '#0eb302'}}>R$ 129,90</span>
                <span className="bg-red-100 text-red-600 px-3 py-1 rounded-full text-sm font-semibold">
                  40% OFF
                </span>
              </div>
              
              <div className="bg-green-50 border border-green-200 rounded-lg p-4 space-y-2">
                <div className="flex items-center justify-center gap-2 text-green-700 font-bold text-lg">
                  <i className="ri-time-line text-xl"></i>
                  <span>ENTREGA EM ATÉ 24 HORAS</span>
                </div>
                <div className="flex items-center justify-center gap-2 text-green-600 font-semibold">
                  <i className="ri-hand-coin-line text-xl"></i>
                  <span>VOCÊ SÓ PAGA NA ENTREGA</span>
                </div>
              </div>
              
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <p className="text-blue-800 font-semibold mb-2">Formas de Pagamento na Entrega:</p>
                <div className="grid grid-cols-2 gap-2 text-sm text-blue-700">
                  <div className="flex items-center gap-2">
                    <i className="ri-money-dollar-circle-line"></i>
                    <span>Dinheiro</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-qr-code-line"></i>
                    <span>PIX</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-bank-card-line"></i>
                    <span>Cartão de Crédito (12x)</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-bank-card-2-line"></i>
                    <span>Cartão de Débito</span>
                  </div>
                </div>
              </div>
            </div>
            
            <Button 
              onClick={handleBuyNow}
              size="lg" 
              className="w-full lg:w-auto text-xl py-5 px-12 flex-col gap-1 bg-[#13d624] hover:bg-[#11c220] text-white shadow-lg hover:shadow-xl"
            >
              <div className="flex items-center">
                <i className="ri-shopping-cart-line mr-2"></i>
                PEDIR AGORA - R$ 129,90
              </div>
              <div className="text-sm font-normal opacity-90">
                PAGAR SÓ NA ENTREGA
              </div>
            </Button>
            
            <div className="flex items-center justify-center gap-6 text-sm text-gray-500">
              <div className="flex items-center gap-1">
                <i className="ri-shield-check-line text-green-500"></i>
                <span>Compra Segura</span>
              </div>
              <div className="flex items-center gap-1">
                <i className="ri-truck-line text-blue-500"></i>
                <span>Entrega 24h</span>
              </div>
              <div className="flex items-center gap-1">
                <i className="ri-medal-line text-yellow-500"></i>
                <span>Garantia 7 dias</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
